"use client";

import { useEffect } from "react";

// Catches errors thrown by the ROOT layout itself (app/layout.tsx),
// which app/error.tsx cannot — without this file a root-layout crash
// renders Next.js's unstyled default. Must render its own <html>/<body>
// and cannot rely on globals.css having loaded.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
    try {
      const messageText = error.message || error.name || String(error) || "(empty error)";
      fetch("/api/errors", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: `Global error [${error.name || "Error"}]: ${messageText}`,
          stack: error.stack,
          digest: error.digest,
          url: typeof window !== "undefined" ? window.location.href : "",
          userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
          context: {
            kind: "global-error-boundary",
            errorName: error.name,
            errorDigest: error.digest,
            errorString: String(error),
            hasMessage: !!error.message,
          },
        }),
        keepalive: true,
      }).catch(() => {});
    } catch {}
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "0 24px",
          backgroundColor: "#ffffff",
          color: "#1a1a1a",
          fontFamily: "Georgia, 'Times New Roman', serif",
        }}
      >
        <div style={{ width: 64, height: 1, backgroundColor: "#C9A961", marginBottom: 32 }} />
        <h1 style={{ fontSize: 24, fontWeight: 400, letterSpacing: "0.02em", margin: 0 }}>
          Something Went Wrong
        </h1>
        <p style={{ marginTop: 16, maxWidth: 420, fontSize: 14, lineHeight: 1.6, color: "#6b6b6b" }}>
          We&apos;re sorry for the inconvenience. Our team has been notified.
        </p>
        <div style={{ marginTop: 32, display: "flex", gap: 16 }}>
          <button
            onClick={reset}
            style={{
              backgroundColor: "#1a1a1a",
              color: "#ffffff",
              border: "none",
              padding: "14px 32px",
              fontSize: 12,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              cursor: "pointer",
            }}
          >
            Try Again
          </button>
          <a
            href="/"
            style={{
              border: "1px solid #1a1a1a",
              color: "#1a1a1a",
              padding: "14px 32px",
              fontSize: 12,
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              textDecoration: "none",
            }}
          >
            Go to Homepage
          </a>
        </div>
        <div style={{ width: 64, height: 1, backgroundColor: "#C9A961", marginTop: 40 }} />
      </body>
    </html>
  );
}
